// extracted by mini-css-extract-plugin
export default {"output":"Output_output__tp-RY"};